import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { roundedTextFieldStyles } from "./roundedTextFieldStyles";

const RoundedPaymentTextField = styled(TextField)(() => ({
  ...roundedTextFieldStyles,
  "& .MuiOutlinedInput-root": {
    ...roundedTextFieldStyles["& .MuiOutlinedInput-root"],
    font: "revert",
    padding: "13px 15px !important",
    fontSize: "18px",
    color: "#2A4876",

    "& input::placeholder": {
      color: "#989899",
      fontSize: "18px",
      fontWeight: 500,
      opacity: 1,
    },
  },
  "& .MuiInputBase-input": {
    ...roundedTextFieldStyles["& .MuiInputBase-input"],
    fontSize: "18px",
    padding: 0,
  },
}));

export default RoundedPaymentTextField;
